const infoContents = {
  headSearch: '1) Выберите опцию для поиска /n2) Введите первые 1 или более символов (поиск в середине слова не поддерживается)/n3) Учитывайте большие и маленькие буквы, регистр важен!'
};

export default infoContents;